import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum WorkComplianceSecurityRight {
    CanAccess = 11000,
    ManageCompliance = 11001,
    ManageComplianceRules = 11002
}

export class WorkComplianceSecurityModule extends BaseSecurityModule<WorkComplianceSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.WorkCompliance,
            [
                { _id: WorkComplianceSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: WorkComplianceSecurityRight.ManageCompliance, name: 'Manage Compliance', basic: true },
                { _id: WorkComplianceSecurityRight.ManageComplianceRules, name: 'Manage Compliance Rules', basic: false },
            ] as SecurityRight<WorkComplianceSecurityRight>[]
        );

        this.plan = TenantSubscription.Professional;
    }


}
